import React from 'react'

export const PageHeading = ({title}) => {
    return (
        <div className='text-black dark:text-white text-sm md:text-base lg:text-xl xl:text-3xl font-bold'>{title}</div>
    )
}
